export const setDirectionsOrigin = (point, label) => ({
  type: 'DIRECTIONS_SET_ORIGIN',
  marker: point,
  label
});

export const setLabelOrigin = (label) => ({
  type: 'DIRECTIONS_LABEL_ORIGIN',
  label
});

export const setDirectionsDestination = (point, label) => ({
  type: 'DIRECTIONS_SET_DESTINATION',
  marker: point,
  label
});

export const setLabelDestination = (label) => ({
  type: 'DIRECTIONS_LABEL_DESTINATION',
  label
});

export const setSelectedPath = (pathID) => ({
  type: 'DIRECTIONS_SET_SELECTED',
  pathID
});

export const enableFlyToPath = () => ({
  type: 'ENABLE_FLY_TO_PATH',
});

export const disableFlyToPath = () => ({
  type: 'DISABLE_FLY_TO_PATH'
});